<template>
  <div>
    <v-alert :value="auth_status === 'loading'" type="info">{{ $t("login.inProgress") }}</v-alert>
    <div style="display: none">
      <slot></slot>
    </div>
    <div v-if="is_user_logged">
      <h1>{{ $t("login.loginSuccess") }}</h1>
      <div>{{ $t("login.welcome") }} <span v-text="user_name"></span></div>
    </div>
    <div v-if="!is_user_logged && canSavePassword">
      <v-form v-model="valid" @submit.prevent="loginClick" ref="form">
        <v-text-field :label="$t('login.company')" :rules="companyRules" @keyup.enter="loginClick" required name="company" v-model="company" />
        <v-text-field :label="$t('login.login')" :rules="loginRules" @keyup.enter="loginClick" required name="login" v-model="login" />
        <v-text-field
          name="password"
          :label="$t('login.password')"
          :rules="passwordRules"
          :type="'password'"
          @keyup.enter="loginClick"
          required
          v-model="password"
        />
        <small
          >{{ $t("login.forgottenPassword") }}
          <router-link to="/profile/password-forgotten">{{ $t("login.resetPassword") }}</router-link>
        </small>
        <br />
        <v-btn type="submit" :disabled="$store.getters['Ajax/loading']">{{ $t("login.button") }}</v-btn>
      </v-form>
    </div>
    <div v-if="!is_user_logged && !canSavePassword">
      <form autocomplete="off" style="position: absolute; top: -800px;">
        <input :label="$t('login.login')" id="lastName" type="text" autocomplete="new-password" />
        <input :label="$t('login.password')" type="password" id="firstName" autocomplete="new-password" />
      </form>
      <v-form v-model="valid" ref="form" autocomplete="off">
        <v-text-field :label="$t('login.company')" :rules="companyRules" @keyup.enter="loginClick" autocomplete="new-password" required v-model="company" />
        <v-text-field :label="$t('login.login')" :rules="loginRules" @keyup.enter="loginClick" required v-model="login" autocomplete="new-password" />
        <v-text-field
          :label="$t('login.password')"
          :rules="passwordRules"
          :type="'password'"
          @keyup.enter="loginClick"
          required
          v-model="password"
          autocomplete="new-password"
        />
        <small
          >{{ $t("login.forgottenPassword") }}
          <router-link to="/profile/password-forgotten">{{ $t("login.resetPassword") }}</router-link>
        </small>
        <br />
        <v-btn @click="loginClick" :disabled="$store.getters['Ajax/loading']">{{ $t("login.button") }}</v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import wnbAddresses from "../wnbAddresses";

export default {
  name: "LoginView",
  data: () => ({
    valid: false,
    company: "",
    login: "",
    password: "",
    canSavePassword: false
  }),
  watch: {
    auth_status(val) {
      if (val === "logged") {
        if (typeof this.$route.params.address !== "undefined") {
          this.$router.replace("/" + this.$route.params.address);
        }
      }
      if (val === "notLogged") {
        this.redirectToWnbIfNeeded();
      }
    },
    is_user_logged() {
      // console.log('Is logged:');
      // console.log(val);
    }
  },
  computed: {
    user_name: function() {
      if (this.$store.getters.userProperties != null) {
        return this.$store.getters.userProperties.name;
      }
      return null;
    },
    is_user_logged: function() {
      return this.$store.getters.isAuthenticated;
    },
    auth_status: function() {
      return this.$store.getters["authStatus"];
    },
    companyRules() {
      if (!this.company) return [this.$t("global.error.required")];
      return [];
    },
    loginRules() {
      if (!this.login) return [this.$t("global.error.required")];
      return [];
    },
    passwordRules() {
      if (!this.password) return [this.$t("global.error.required")];
      return [];
    }
  },
  methods: {
    loginClick: function() {
      if (this.$refs.form.validate()) {
        let user = {
          company: this.company,
          username: this.login,
          password: this.password
        };
        this.$store
          .dispatch("AUTH_REQUEST", user)
          .then(() => {
            if (typeof this.$route.params.address !== "undefined") {
              //this.$router.push(this.$route.params.address);
              this.$router.replace("/" + this.$route.params.address); //.catch(err => {
              //   console.log(err);
              // });
              //this.$router.push("/delegation");
            }
          })
          .catch(err => {
            if (err.response.status === 429) {
              this.$store.dispatch("alertDialog", {
                content: this.$t("login.tooManyAttemptsDialog.content"),
                title: this.$t("login.tooManyAttemptsDialog.title")
              });
            } else {
              if (err.response.data.message === "Password expired") {
                this.$store
                  .dispatch("alertDialog", {
                    content: this.$t("login.passwordExpired.content"),
                    title: this.$t("login.passwordExpired.title")
                  })
                  .then(() => {
                    this.$router.push("/password-expired");
                  });
              } else if (err.response.data.message === "Your IP is not allowed") {
                this.$store.dispatch("alertDialog", {
                  content: this.$t("login.loginFailedIPNotAllowed.content"),
                  title: this.$t("login.loginFailedIPNotAllowed.title")
                });
              } else {
                this.$store.dispatch("alertDialog", {
                  content: this.$t("login.loginFailedDialog.content"),
                  title: this.$t("login.loginFailedDialog.title")
                });
              }
            }
          });
      }
    },
    externalAddresses: wnbAddresses,
    redirectToWnbIfNeeded() {
      if (this.$store.getters["isWnbUser"] && this.$store.getters["authStatus"] !== "loading") {
        window.location.replace(
          this.externalAddresses("LOGIN") + "?delegations=/" + (typeof this.$route.params.address === "undefined" ? "" : this.$route.params.address)
        ); //TODO REDIRECT USTALIC Z JERZYM WNB
      }
    }
  },
  created() {
    this.axios.get("/auth/get-general-settings").then(resp => {
      this.$store.commit("SET_IS_WNT", resp.data.is_wnt === 2);
      if (parseInt(resp.data.login_password_save) === 2) {
        this.canSavePassword = true;
      }
    });
    this.redirectToWnbIfNeeded();
  }
};
</script>

<style scoped></style>
